// utils/languages.ts
//
// Single list of the languages a user can pick as their preferred language
// (Register, admin UserManager). Codes match the ones the backend's
// languageDetect.js already understands, so no backend change is needed.

export interface AppLanguage {
  code: string;
  /** Name in the language itself, shown in dropdowns. */
  nativeName: string;
  englishName: string;
}

export const APP_LANGUAGES: readonly AppLanguage[] = [
  { code: "en", nativeName: "English", englishName: "English" },
  { code: "th", nativeName: "ไทย", englishName: "Thai" },
  { code: "vi", nativeName: "Tiếng Việt", englishName: "Vietnamese" },
  { code: "id", nativeName: "Bahasa Indonesia", englishName: "Indonesian" },
  { code: "ms", nativeName: "Bahasa Melayu", englishName: "Malay" },
  { code: "fil", nativeName: "Filipino", englishName: "Filipino" },
  { code: "ko", nativeName: "한국어", englishName: "Korean" },
  { code: "ja", nativeName: "日本語", englishName: "Japanese" },
  { code: "zh", nativeName: "中文", englishName: "Chinese" },
  { code: "hi", nativeName: "हिन्दी", englishName: "Hindi" },
  { code: "es", nativeName: "Español", englishName: "Spanish" },
  { code: "ar", nativeName: "العربية", englishName: "Arabic" },
  { code: "pt", nativeName: "Português", englishName: "Portuguese" },
  { code: "fr", nativeName: "Français", englishName: "French" },
  { code: "de", nativeName: "Deutsch", englishName: "German" },
];

export const isAppLanguage = (code?: string | null): code is string =>
  !!code && APP_LANGUAGES.some((language) => language.code === code);

/** Dropdown label, e.g. "ไทย (Thai)"; plain "English" for English itself. */
export const getLanguageOptionLabel = (language: AppLanguage): string =>
  language.nativeName === language.englishName
    ? language.nativeName
    : `${language.nativeName} (${language.englishName})`;
